import { Loader } from '@tfo/common'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const SsoDirectRedirect = () => {
    const { companyId } = useParams<{ companyId: string }>()

    useEffect(() => {
        const apiBaseUrl = `https://${(window as any).tfoEnv}`
        const returnUrl = `${window.location.origin}/sso`
        const ssoUrl = `${apiBaseUrl}/authenticate/sso/auth?companyId=${encodeURIComponent(companyId)}&returnUrl=${encodeURIComponent(returnUrl)}`
        window.location.href = ssoUrl
    }, [companyId])

    console.log('Redirecting to SSO provider...')
    return <Loader />
}

export default SsoDirectRedirect
